<template>
<div>
  <el-drawer
   :model-value="modelValue" 
   direction="rtl" 
   size="100%" 
   append-to-body
   destroy-on-close 
   :custom-class="headerBorderNo ? 'header-border-no right-slider-drawer' : 'right-slider-drawer'"
   modal-class="right-slider-modal" 
   :modal="false" 
   :show-close="false">
    <template #header>
      <div v-if="title" class="title">{{title}}</div>
      <slot name="headerCustom"></slot>
      <img src="@/assets/img/task_close.png" @click="hideSlider" class="slider-close" />
    </template>
    <template #default>
      <slot name="sliderMain"></slot>
    </template>
    <template #footer>
      <slot name="footer"></slot>
    </template>
  </el-drawer>
  <slot></slot>
</div>
</template>

<script>
export default {
  name: 'right-slider',
  props: {
    modelValue: Boolean,
    title: String,
    listenerIds: {
      type: Array,
      default: () => {
        return ['app']
      }
    },
    noListenerIds: {
      type: Array,
      default: () => ['adminui-main']
    },
    noListenerClass: {
      type: Array,
      default: () => []
    },
    headerBorderNo: { // 是否header有border
      type: Boolean,
      default: false
    }
  },
  data () {
    return {}
  },
  mounted () {
    // this.listenerIds.forEach(item => {
    //   if (document.getElementById(item)) {
    //     console.log('add event listener', item)
    //     document.getElementById(item).addEventListener('click', this.documentClickHandle, false)
    //   }
    // })
  },
  methods: {
    hideSlider () {
      this.$emit('hideSlider')
    },
    // documentClickHandle (e) {
    //   let hidden = true
    //   this.noListenerIds.forEach(element => {
    //     console.log('element', element)
    //     if (document.getElementById(element) && document.getElementById(element).contains(e.target)) {  
    //       hidden = false
    //     }
    //   })

    //   this.noListenerClass.forEach(element => {
    //     const items = document.getElementsByClassName(element)
    //     if (items && hidden) {
    //       for (let index = 0; index < items.length; index++) {
    //         const element = items[index]
    //         if (element.contains(e.target)) {
    //           hidden = false
    //           break
    //         }
    //       }
    //     }
    //   })
    //   if (hidden) {
    //     this.hideSlider()
    //   }
    // }
  }
}
</script>

<style lang="scss" scoped>
.right-slider-modal {
  .right-slider-drawer {
    .el-drawer__close-btn {
      .el-icon {
        font-size: 30px;
      }
    }
    .title {
      font-size: 17px;
      color: #666;
    }
    .slider-close {
      width: 40px;
      height: 40px;
      padding: 10px;
      cursor: pointer;
    }
  }
}
</style>
<style lang="scss">
.right-slider-modal {
  left: 20% !important;
  top: 51px !important;
  .right-slider-drawer {
    // top: 51px !important;
    // height: calc(100% - 51px) !important;
    .el-drawer__header {
      padding: 0 0 0 10px;
      margin-top: 5px;
      margin-bottom: 0;
      border-bottom: 1px solid #eee;
    }
    .el-drawer__body {
      padding: 0;
      overflow-x: hidden;
      // .el-tabs__header {
      //   padding: 0 17px;
      //   background-color: #f5f6f9
      // }
      .el-tabs__nav-scroll {
        background-color: #f5f6f9;
        padding: 0 17px;
      }
    }
  }
  .right-slider-drawer.header-border-no {
    .el-drawer__header {
      border-bottom: none;
    }
  }
}
</style>